import { Form, Input } from 'antd';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { MobileOutlined } from '@ant-design/icons';
import PhoneNumber from 'awesome-phonenumber';

export interface MultiFactorPhoneNumberFormValues {
  phoneNumber: string;
}

interface MultiFactorPhoneNumberFormProps {
  control: Control<MultiFactorPhoneNumberFormValues>;
  onSubmit: () => void;
}

const TEST_PHONE_NUMBER = '+11231231234';

const MultiFactorPhoneNumberForm: React.FC<MultiFactorPhoneNumberFormProps> = ({ control, onSubmit }) => {
  return (
    <>
      <Form layout="vertical" name="login-form" onFinish={onSubmit}>
        <Controller
          control={control}
          name="phoneNumber"
          rules={{
            required: 'Please input your phone number',
            validate: (value) => {
              const phoneNumber = PhoneNumber(value, 'US');
              if (!phoneNumber.isValid() && phoneNumber.getNumber() !== TEST_PHONE_NUMBER) {
                return 'Please input a valid phone number';
              }
              return true;
            },
          }}
          render={({ field, fieldState }) => (
            <Form.Item validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
              <Input
                size="large"
                className="border-content-secondary shadow-none"
                autoCapitalize="off"
                autoCorrect="off"
                placeholder="Phone number"
                prefix={<MobileOutlined className="text-content-secondary mr-1" />}
                {...field}
              />
            </Form.Item>
          )}
        />
      </Form>
    </>
  );
};

export default MultiFactorPhoneNumberForm;
